export default __webpack_public_path__ + "static/media/star.ddb056fd.svg";